import { SwiftFoxOrganisationDetails, SwiftFoxPersonDetails } from '../membership-form-template/contracts';
import { OrganisationDetails } from './organisation-details';
import { PersonalDetails } from './personal-details';
import { ProfileForm } from './shared/profile-form';

export function Profile({ useLinkedOrganisationData }: { useLinkedOrganisationData: boolean }) {
	return useLinkedOrganisationData ? (
		<ProfileForm<SwiftFoxOrganisationDetails>
			fetchUrl="GetOrganisation"
			updateUrl="UpdateOrganisation"
			profileComponent={OrganisationDetails}
			useLinkedOrganisationData={true}
		/>
	) : (
		<ProfileForm<SwiftFoxPersonDetails>
			fetchUrl="GetPerson"
			updateUrl="UpdatePerson"
			profileComponent={PersonalDetails}
			useLinkedOrganisationData={false}
		/>
	);
}
